import { render, staticRenderFns } from "./shopClose.vue?vue&type=template&id=3540eb02&scoped=true&"
import script from "./shopClose.vue?vue&type=script&lang=js&"
export * from "./shopClose.vue?vue&type=script&lang=js&"
import style0 from "./shopClose.vue?vue&type=style&index=0&id=3540eb02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540eb02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3540eb02')) {
      api.createRecord('3540eb02', component.options)
    } else {
      api.reload('3540eb02', component.options)
    }
    module.hot.accept("./shopClose.vue?vue&type=template&id=3540eb02&scoped=true&", function () {
      api.rerender('3540eb02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/shopClose.vue"
export default component.exports